import { cn } from "@utils";
import { WORKING_SET_COLOURS, WORKING_SET_ICONS } from "../hooks/workingSets";

const OPTION =
  "flex size-9 items-center justify-center rounded-lg border transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500";

export const WorkingSetIconPicker = ({ value, onChange }) => (
  <div className="grid w-fit grid-cols-6 gap-2" role="radiogroup" aria-label="Icon">
    {Object.entries(WORKING_SET_ICONS).map(([key, Icon]) => (
      <button
        key={key}
        type="button"
        role="radio"
        aria-label={key}
        aria-checked={value === key}
        onClick={() => onChange(key)}
        className={cn(
          OPTION,
          value === key
            ? "border-zinc-900 bg-zinc-900 text-white"
            : "border-zinc-200 bg-white text-zinc-500 hover:border-zinc-300 hover:text-zinc-800",
        )}
      >
        <Icon aria-hidden="true" className="size-4" />
      </button>
    ))}
  </div>
);

export const WorkingSetColourPicker = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Colour">
    {Object.entries(WORKING_SET_COLOURS).map(([key, tone]) => (
      <button
        key={key}
        type="button"
        role="radio"
        aria-label={key}
        aria-checked={value === key}
        onClick={() => onChange(key)}
        className={cn(
          OPTION,
          tone.tile,
          value === key ? "border-zinc-900 ring-1 ring-zinc-900" : "border-transparent hover:border-zinc-300",
        )}
      >
        <span className={cn("size-3.5 rounded-full", tone.dot)} />
      </button>
    ))}
  </div>
);

export default WorkingSetIconPicker;
